export const property = {
  gamefi: "Compte de jeu",
  mc_official_verify_unofficial: "Canal non officiel non vérifié",
  mc_official_verify_official: "Officiel",
  mc_official_verify_fotter_tip_1:
    "Avertissement concernant la prévention de la fraude en ligne/téléphonique par des personnes se faisant passer pour le personnel officiel de Biking",
  mc_official_verify_fotter_tip_2:
    "Déclaration sérieuse et avertissement concernant la prévention des fraudeurs se faisant passer pour 'Biking' ou abusant de son nom",
  mc_official_verify_modal_tip_1:"Le 【{query}】 que vous avez vérifié est confirmé comme un canal officiel de Biking",
  mc_official_verify_modal_tip_3: "Veuillez vérifier que les informations saisies et le format sont corrects :",
  mc_official_verify_modal_tip_4: "Numéro de téléphone : xx-xxxxxxxxx",
  mc_official_verify_modal_type_email: "E-mail",
  mc_official_verify_modal_type_domain: "Site web",
  mc_official_verify_modal_type_channel: "Canal",
  mc_official_verify_input_placeholder: "Veuillez saisir les informations correctes et le bon format pour vérifier",
  mc_official_verify_head_title: "Canal de vérification officiel de Biking Exchange | Biking Exchange",
  mc_official_verify_head_description: "Canal de vérification officiel de Biking Exchange",
  mc_official_verify_title: "Canal de vérification officiel",
  mc_official_verify_discription_new:"Pour éviter les pertes d'actifs dues au hameçonnage et aux fraudes en ligne, vous pouvez vérifier sur cette page si les sites web, adresses e-mail, numéros de téléphone, ou les comptes de réseaux sociaux comme Twitter ou Telegram sont des canaux officiels certifiés par Biking.",
  mc_official_verify_fotter_tip_3:"À lire absolument pour les utilisateurs de Biking : Manuel de prévention des fraudes, attention aux nouvelles tactiques frauduleuses !",
  mc_unofficial_verify_modal_tip_1:"Le 【{query}】 que vous avez vérifié n'est PAS un canal officiel de Biking",
  mc_official_verify_discription:"Pour empêcher les fraudeurs d'utiliser le nom de Biking Global pour escroquer, vous pouvez utiliser cette page pour confirmer si les appels téléphoniques, WeChat, etc. qui vous contactent sont des canaux officiels de Biking.",
  mc_official_head_title1: "Vérifier les canaux officiels, actualités et publications de Biking",
  mc_official_head_keywords1: "Vérification Biking, Actualités Biking, Compte officiel Biking",
  mc_official_head_description1:"Assurez-vous de l'authenticité des canaux Biking. Utilisez notre outil de vérification officiel pour confirmer la légitimité des chaînes, actualités et publications liées à Biking.",
  mc_official_verify_verified_title: "Canaux officiels certifiés",
  mc_official_verify_modal_tip_5:"Telegram/X/Facebook/Youtube : @xxxxx (avec le symbole @)",
  mc_official_verify_modal_tip_6: "TikTok/Instagram : xxxx (sans le symbole @)",
  mc_official_verify_modal_tip_7: "Discord : xxxx#xxxx (sans le symbole @)",
  mc_official_verify_modal_tip_8:"Linkedin/Groupe Telegram/Medium/Reddit : https://xxxxx (lien du site web)",
  mc_official_verify_modal_tip_9: "Si vous avez des questions sur le format des informations, n'hésitez pas à contacter notre service client en ligne.",
  mc_official_verify_modal_tip_10: "*Ne révélez jamais les informations de votre compte et votre mot de passe à qui que ce soit.",
  mc_official_verify_modal_tip_11:"*Méfiez-vous des fraudes et agissez avec prudence.",
  tagtip: "Si la plateforme de dépôt ne demande pas de Comment, ce champ peut être laissé vide",
  tagtip1: "Le Tag est un code unique utilisé pour identifier un compte ou un utilisateur spécifique, garantissant que les fonds sont envoyés au bon destinataire.",
  tagtip2: "D'autres plateformes de trading ou portefeuilles peuvent appeler le Tag : ID numérique, Tag, Memo, Note, Remarque, etc.",
  tag: "Veuillez entrer le Commentaire",
  qbcbcg: "Veuillez copier à la fois l'adresse TON et le commentaire pour garantir le succès du dépôt",
  qsrzqje: "Veuillez entrer un montant valide",
  games: "Compte de jeu",
  cbxz: "Instructions pour le dépôt sur Ethereum (ERC20)",
  tbxz: "Instructions pour le retrait sur Ethereum (ERC20)",
  ctbzysx: "Veuillez noter que chaque transfert via le contrat intelligent officiel FUFU entraîne des frais supplémentaires de 2%.",
  dzcw: "Adresse incorrecte",
  czqkqrs: "Nombre de confirmations de bloc pour le dépôt",
  mc: "Nom",
  cjsj: "Date de création",
  lx: "Type",
  sl: "Quantité",
  cwjl: "Relevés financiers",

  ylzh: "Profit",
  ddtx: "Retrait en attente",
  txcg: "Retrait réussi",
  yhcx: "Annulé par l'utilisateur",
  qbcbjl: "Historique complet des dépôts",

  zczl: "Aperçu des actifs",
  zjzh: "Compte de financement",
  mbzh: "Compte d'achat",
  xhzh: "Compte Spot",
  hyzh: "Compte Futures",
  lczh: "Compte de financement",
  gdzh: "Compte de copie de trading",
  giftzh: "Compte de bonus",
  bwzh: "Carte du Roi des cryptos",
  mozh: "Compte de démonstration",
  mnhy: "Futures de démonstration",
  sxffy: "Commission système",
  kt: "Airdrop",
  xtkc: "Déduction système",
  zcfb: "Répartition des actifs",
  zcdt: "Dynamique des actifs",
  zh: "Compte",
  zc: "Actif",
  czjl: "Historique des dépôts",
  txls: "Historique des retraits",
  hzjl: "Historique des transferts",
  mmjl: "Historique des achats/ventes",
  cb: "Dépôt de crypto",
  tx: "Retrait",
  hz: "Transférer",
  mb: "Acheter de la crypto",
  jy: "Transaction",
  zwsj: "Aucune donnée",
  ckqb: "Voir tout",

  // table
  bz: "Devise",
  qc: "Nom complet",
  zhze: "Total du compte",
  syzc: "Actif restant",
  djzc: "Actif gelé",
  cz: "Opération",
  sl: "Quantité",
  cbdz: "Adresse de dépôt",
  sj: "Heure",
  zt: "Statut",
  ms: "Description",
  hzfx: "Direction du transfert",
  hzse: "Montant du transfert",
  txdz: "Adresse de retrait",
  sxf: "Frais",
  ddh: "Numéro de commande",
  zj: "Prix total",
  dj: "Prix unitaire",
  jysl: "Quantité échangée",
  jydx: "Contrepartie",
  zhqy: "Capitaux propres du compte",
  zhqytips: "Capitaux propres du compte = Marge disponible + Marge de position",
  kybzj: "Marge disponible",
  kybzjtips: "Marge pouvant être utilisée pour ouvrir des positions ou être transférée",
  cwbzj: "Marge de position",
  cwbzjtips: "Marge utilisée pour maintenir les positions actuelles",

  // search
  srbz: "Veuillez saisir la devise correspondante",
  ycxzc: "Masquer les petits actifs",
  sy: "Tous",
  qb: "Tout",
  qx: "Tout sélectionner",
  zhi: "à",
  ksrq: "Date de début",
  jsrq: "Date de fin",
  cx: "Rechercher",
  dc: "Exporter",
  zjqt: "7 derniers jours",
  zjygy: "30 derniers jours",
  qbsj: "Toutes les périodes",
  usdt: "USDT",
  ddlx: "Type d'ordre",
  gm: "Acheter",
  cs: "Vendre",

  // recharge
  czxq: "Détails du dépôt",
  usdtcbjl: "Historique des dépôts en {coinName}",
  cbsl: "Montant du dépôt",
  cbzt: "Statut du dépôt",
  crdbz: "Veuillez sélectionner la devise à déposer",
  tqdbz: "Veuillez sélectionner la devise à retirer",
  rmbz: "Devises populaires",
  qxz: "Veuillez sélectionner",
  cbwl: "Réseau de dépôt",
  cbtips: "Assurez-vous d'avoir sélectionné le même réseau que la plateforme de retrait pour le dépôt, sinon vous risquez de perdre vos actifs.",
  txfs: "Méthode de retrait",
  lstx: "Retrait on-chain",
  xyb: "Suivant",
  yxzdq: "Sélectionné actuellement",
  dbz: "devise",
  cxxz: "Resélectionner",
  dzkbz: "Adresses insuffisantes dans la base d'adresses, veuillez contacter l'administrateur.",
  qxzcrdbz: "Veuillez d'abord sélectionner la devise à déposer",
  qxzcbwl: "Veuillez sélectionner le réseau de dépôt",
  qxztqdbz: "Veuillez d'abord sélectionner la devise à retirer",
  cr: "Déposer",
  tq: "Retirer",
  cbxq: "Détails du dépôt",
  txxq: "Détails du retrait",
  usdttxjl: "Historique des retraits en {coinName}",
  qbtxjl: "Historique complet des retraits",
  zyxx: "Information importante : vous ne pouvez envoyer que {coinName} à cette adresse. Si vous envoyez d'autres cryptomonnaies, vous perdrez ces fonds.",
  jzjcr: "Déposer des fonds sur",
  smewm: "Scannez le code QR ou copiez les informations suivantes sur la plateforme d'envoi",
  xcdzcz: "Recharger cette adresse avec un type de jeton différent entraînera la perte de vos actifs",
  xcdzczss: "Lorsque vous déposez du XRP, assurez-vous de copier le tag, sinon vous risquez de perdre vos fonds",
  znhycz: "Les dépôts via contrat intelligent, dépôts groupés ou récompenses de bloc ne sont pas pris en charge pour le moment.",
  usdtcbdz: "Adresse de dépôt {coinName}",
  fzdz: "Copier l'adresse",
  usdtdz: "Adresse {coinName}",
  zxcbe: "Montant minimum de dépôt",
  zytx2:
    "Information importante : assurez-vous que la plateforme réceptrice prend en charge le réseau {coinName} que vous avez choisi, sinon vous perdrez ces fonds.",
  kytxwl: "Réseaux de retrait disponibles pour {coinName}",
  xzwl: "Sélectionner le réseau",
  dzym: "Adresse {coinName}",
  srdz: "Entrez l'adresse ou sélectionnez dans le carnet d'adresses",
  jymm: "Mot de passe de trading",
  qsrjymm: "Veuillez entrer le mot de passe de trading",
  zxtbe: "Montant minimum de retrait : {minAmount}",
  ky: "Disponible :",
  zhztbxe: "Limite totale de retrait du compte",
  gjxyddj:
    "En fonction de votre niveau de vérification, vous ne pouvez retirer qu'un montant limité sur 24 heures. Cette limite convertira l'USD dans la cryptomonnaie de votre choix.",
  scbdjd:
    "En raison de la volatilité des prix, les frais pour cette cryptomonnaie sont variables. Basés sur le prix moyen des 24 heures, des frais équivalant à 0,2-0,2 USDT seront prélevés. Augmentez les frais pour accélérer la réception.",
  yqdz: "Réception prévue",
  yqdzwf: "La réception prévue ne peut pas être négative",
  sfrz: "Vérification d'identité",
  ggyzm: "Code Google Authenticator",
  dxyzm: "Code de validation SMS",
  yxyzm: "Code de validation e-mail",
  qsryzm: "Veuillez entrer le code de validation",
  fsyzm: "Envoyer le code",
  cxfs: "Renvoyer",
  tj: "Soumettre",
  qxztxwl: "Veuillez sélectionner le réseau de retrait",
  qsrdz: "Veuillez entrer l'adresse",

  qxzdz: "Veuillez sélectionner l'adresse",
  qxzyzfs: "Veuillez sélectionner une méthode de vérification d'identité",
  qsrtqsl: "Veuillez entrer le montant à retirer",
  qwcyz: "Veuillez compléter la vérification",
  qqrbdsj: "Veuillez d'abord confirmer si le numéro de téléphone est lié",
  qqrbdyx: "Veuillez d'abord confirmer si l'e-mail est lié",
  fzcg: "Copié avec succès !",
  tbcg: "Retrait de crypto réussi",
  usdttxdz: "Adresse de retrait {coinName}",
  lmc: "Nom de la chaîne :",
  qtj: "*Veuillez ajouter",
  dz: "l'adresse",
  fei: "Non",
  zjds: "l'adresse peut entraîner une perte d'actifs",
  yzfs: "Méthode de vérification",
  yzm: "Code de validation",
  remark: "Remarque",
  qsrremark: "Veuillez entrer une remarque",
  tjdzcg: "Adresse ajoutée avec succès",
  qxxzyzfs: "Veuillez d'abord sélectionner la méthode de vérification",
  qsrtxdz: "Veuillez entrer l'adresse de retrait",

  stop: "Suspendu",

  // status
  qr0: "0 confirmation",
  qr1: "1 confirmation",
  dqr: "En attente de confirmation",
  czcg: "Dépôt réussi",
  hzz: "Transfert en cours",
  ywc: "Terminé",
  sb: "Échoué",
  zzcl: "En traitement",
  ddsh: "En attente de vérification",
  txcg: "Retrait réussi",
  cxcg: "Annulation réussie",
  ddtx: "Retrait en attente",
  txsb: "Retrait échoué",
  slsb: "Échec de la transmission on-chain",
  dfk: "En attente de paiement",
  yfk: "Payé",
  yqx: "Annulé",
  ssz: "En litige",
  gdfrhz: "Transfert de partage de profits (copie de trading)",
  hyzh_to_gdzh: "Compte Futures -> Compte de copie de trading",
  gdzh_to_hyzh: "Compte de copie de trading -> Compte Futures",
  ddcl: "En attente de traitement",
  cg: "Succès",

  // dialog
  zchz: "Transfert d'actifs",
  ljhz: "Transférer maintenant",
  cong: "De",
  dao: "À",
  qtzh: "Autre compte",
  qxzbz: "Veuillez sélectionner la devise",
  qsrsl: "Veuillez entrer la quantité",
  khz: "Transferable :",
  ye: "Solde :",
  hzcg: "Transfert réussi",

  // h5
  zcgl: "Aperçu des actifs",
  xrzx: "Offres exclusives nouveaux arrivants",
  zzc: "Actif total",
  jryk: "PL journalier",
  zgjz: "Pack de bienvenue jusqu'à 3200 USDT à gagner",
  zhrj: "Alimentez votre compte",
  xzrjfs: "Après avoir alimenté, vous pouvez acheter des cryptomonnaies. Choisissez la méthode de dépôt selon votre situation.",
  czszhb: "Déposer des cryptomonnaies",
  yyydszhb: "Déposez des cryptomonnaies que vous possédez déjà sur d'autres plateformes vers votre compte Biking.",
  czfb: "Déposer des devises fiduciaires (Fiat)",
  czzhz:
    "Déposez des devises fiduciaires que vous possédez vers votre compte Biking, via carte bancaire, virement, etc.",
  maibi: "Acheter de la crypto",
  tgdsfmb: "Acheter des cryptomonnaies par carte bancaire, P2P, plateforme tierce, etc.",
  yqyl: "Inviter des amis",
  yqfy: "Gagnez 20% de commission sur les frais de vos amis",
  cxzzn: "Guide du débutant",
  czzh: "Créer un compte Biking",
  hdxrj: "Obtenez un bonus de bienvenue de 100 USDT",
  ck: "Déposer",
  tzndzh: "Investissez dans votre compte et commencez votre voyage, plusieurs méthodes de paiement disponibles",
  wcsfrz: "Effectuez la vérification d'identité (KYC)",
  hgzh: "Effectuez le KYC et devenez un compte conforme",
  ksjy: "Commencer à trader",
  tsgd: "Vendez, achetez ou copiez des transactions, explorez plus d'options",
  ksndlc: "Commencez votre voyage",
  kjydjmhb: "Cryptomonnaies tradables",
  jmhb: "La capitalisation totale des cryptomonnaies est de 1228,485 milliards USD",
  zengjin: "Bonus",
  lc: "Finance",
  mb: "Acheter de la crypto",
  lsjl: "Historique",
  zclb: "Liste des actifs",
  shaixuan: "Filtrer",
};


// WEBPACK FOOTER //
// ./src/i18n/lang/property/fr.js